export default __webpack_public_path__ + "images/56eded61551559cbf753c04f8c46dd0d.svg";